// Import third-party CSS first so our custom styles can override them
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'timepicker.js/dist/timepicker.min.css';
import 'timepicker.js/dist/timepicker.min.js';
import 'react-datepicker/dist/react-datepicker.css';

// Import our custom styles last to ensure they override third-party defaults
import './style';
import App from './components/app';

// Hand a native-app Untappd OAuth callback back to the mobile app BEFORE the
// SPA renders or the auth gate can redirect an unauthenticated in-app browser
// to the login page. Must run first. See services/untappdAppBounce.js.
import { handleUntappdAppBounce } from './services/untappdAppBounce';
handleUntappdAppBounce();

// Chrome on iOS renders the first load of a tab opened from another app (the
// Camera QR scan, the native app's device hand-off) under its own toolbar. A
// second navigation fixes the cold launch; a blank-tab open/close on the first
// tap fixes an already-running Chrome. See utils/chromeIosRelayout.js.
import { captureBootHref, initViewportDiag } from './utils/viewportDiag';
captureBootHref();

import { relayoutChromeIosIfNeeded } from './utils/chromeIosRelayout';
relayoutChromeIosIfNeeded();

// Opt-in, per-device viewport diagnostic overlay (issue #249). Renders nothing
// unless ?ktdiag=1 armed it on this browser. See utils/viewportDiag.js.
initViewportDiag();

// Set up global auth error handling
import { setupAuthInterceptor } from './services/authInterceptor';
setupAuthInterceptor();

// Set up global API error handling to prevent unhandled rejections
import { setupApiErrorHandler } from './services/apiErrorHandler';
setupApiErrorHandler();

// Set up error logging for debugging blank screen issues
import './utils/errorLogger';

// Recover from stale lazy-route chunks after a deploy. The new service worker
// takes over open tabs and drops the previous build's chunks from the
// precache; a tab still running that build then gets the SPA fallback's HTML
// where it expected JS, webpack chokes on '<', and the route renders blank.
// Reload once per build id to pick up the current shell; after that, show a
// message with a Reload button (components/chunk-error-notice).
import { installChunkErrorRecovery } from './utils/chunkReload';
installChunkErrorRecovery();

export default App;
